import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';

interface Deps { membershipRepository: IMembershipRepository; }
export interface AssignPermissionInput { roleId: string; permissionId: string; }
export function createAssignPermissionToRoleUseCase({ membershipRepository }: Deps) {
  return async function assignPermissionToRole(input: AssignPermissionInput): Promise<void> {
    return membershipRepository.assignPermissionToRole(input);
  };
}
